import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { toUniqueKey } from "../Community/MainContent/MainContent";
import { Language, useLanding } from "../Sustainability.hook";
import { fields, fieldsReady } from "./constants";
import { LandingPageHeading } from "./LandingPageHeading";
export const Landing: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const { data: profileData, isLoading: isLoadingProfile, refetch: refetchOurProfile } = useLanding();
  const {
    data: profileDataById,
    isLoading: isLoadingprofileById,
    refetch: refetchOurProfileById,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("profileDataById", profileDataById, profileData, payloadData);

  useEffect(() => {
    if (query?.get("id")) {
      setPayloadData(profileDataById?.payload);
    } else {
      setPayloadData(profileData);
    }
  }, [profileData, profileDataById]);

  useEffect(() => {
    if (approveId) {
      refetchOurProfileById();
    } else {
      refetchOurProfile();
    }
  }, [query.get("subActiveTab"), approveId, query.get("activeTab")]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);
  const createFormConfig = (name?: string, idx1?: any, field?: any): FormConfig => {
    const getMarkupValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];
      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.cardData?.[idx1]?.description);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.cardData?.[idx1]?.description);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.description);
    };
    const getTitleValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.cardData?.[idx1]?.title);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.cardData?.[idx1]?.title);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.title);
    };
    const getLinkValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.cardData?.[idx1]?.link);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.cardData?.[idx1]?.link);
        }
      }

      return decodeHTML(profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.link);
    };
    const getImageValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];

      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML([
              {
                uid: "-1",
                name: "image.png",
                status: "done",
                url: JSON.parse(payload)?.data?.cardData?.[idx1]?.image,
              },
            ]);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: payload?.data?.cardData?.[idx1]?.image || undefined,
            },
          ]);
        }
      }

      return decodeHTML([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.image || undefined,
        },
      ]);
    };

    return {
      initialValues: {
        [`field_content_english.data.cardData[${idx1}].image`]: getImageValue("field_content_english"),
        [`field_content_english.data.cardData[${idx1}].title`]: getTitleValue("field_content_english"),
        [`field_content_english.data.cardData[${idx1}].description`]: getMarkupValue("field_content_english"),
        [`field_content_english.data.cardData[${idx1}].link`]: getLinkValue("field_content_english"),
        [`field_content_malay.data.cardData[${idx1}].image`]: getImageValue("field_content_malay"),
        [`field_content_malay.data.cardData[${idx1}].title`]: getTitleValue("field_content_malay"),
        [`field_content_malay.data.cardData[${idx1}].description`]: getMarkupValue("field_content_malay"),
        [`field_content_malay.data.cardData[${idx1}].link`]: getLinkValue("field_content_malay"),
        [`field_content_mandarin.data.cardData[${idx1}].image`]: getImageValue("field_content_mandarin"),
        [`field_content_mandarin.data.cardData[${idx1}].title`]: getTitleValue("field_content_mandarin"),
        [`field_content_mandarin.data.cardData[${idx1}].description`]: getMarkupValue("field_content_mandarin"),
        [`field_content_mandarin.data.cardData[${idx1}].link`]: getLinkValue("field_content_mandarin"),
      },
      fields: field,
    };
  };

  const updatePayload = (data: any) => {
    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        let currentObj = result;
        const parts = key.split(".");
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i];
          const matches = part.match(/(\w+)\[(\d+)\]/);
          if (matches) {
            const [_, arrayName, index] = matches;
            currentObj[arrayName] = currentObj[arrayName] || [];
            if (i === parts.length - 1) {
              currentObj[arrayName][parseInt(index)] = obj[key];
            } else {
              currentObj[arrayName][parseInt(index)] = currentObj[arrayName][parseInt(index)] || {};
              currentObj = currentObj[arrayName][parseInt(index)];
            }
          } else {
            if (i === parts.length - 1) {
              currentObj[part] = obj[key];
            } else {
              currentObj[part] = currentObj[part] || {};
              currentObj = currentObj[part];
            }
          }
        }
      }
      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};

      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key].map((item: any) => (typeof item === "object" ? filterNestedObjects(item) : item));
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };
    const replacePayload = (target: any, source: any) => {
      console.log("imageDataorg", source);
      for (const key in source) {
        if (key === "image") {
          const imageData = source[key];
          console.log("imageDataorg", imageData, source);
          if (Array.isArray(imageData)) {
            if (imageData[0]?.originFileObj) {
              console.log("imageDataorg", imageData);
              target[key] = imageData;
            } else {
              target[key] = imageData[0]?.url ?? undefined;
            }
          } else if (typeof imageData === "object" && imageData !== null) {
            // Ensure `undefined` values are explicitly handled
            target[key] = imageData.url !== undefined ? imageData.url : undefined;
          } else {
            target[key] = undefined;
          }
        } else if (Array.isArray(source[key])) {
          // Initialize array if it doesn't exist
          target[key] = target[key] || [];

          // Process each array element
          source[key].forEach((item: any, index: number) => {
            if (item !== null && item !== undefined) {
              if (typeof item === "object") {
                target[key][index] = target[key][index] || {};
                replacePayload(target[key][index], item);
              } else {
                target[key][index] = item;
              }
            }
          });
        } else if (typeof source[key] === "object" && source[key] !== null) {
          target[key] = target[key] || {};
          replacePayload(target[key], source[key]);
        } else {
          target[key] = source[key] !== undefined ? source[key] : target[key];
        }
      }
    };
    const convertedData = convertDotNotation(data);
    const filteredData = convertedData; // filterNestedObjects(convertedData);
    let payload = payloadData;
    if (profileDataById?.payload) {
      try {
        payload.field_content_english = JSON.parse(payload?.field_content_english);
        payload.field_content_malay = JSON.parse(payload?.field_content_malay);
        payload.field_content_mandarin = JSON.parse(payload?.field_content_mandarin);
      } catch (error) {
        throw new Error("Invalid JSON string in content fields");
      }
    } else {
      payload = profileData[0];
    }
    payload = JSON.parse(JSON.stringify(payload));
    replacePayload(payload, filteredData);
    return payload;
  };
  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const updateNestedProperty = (obj: any, path: string, value: any) => {
      const keys = path.split(".");
      let current = obj;
      for (let i = 0; i < keys.length - 1; i++) {
        if (keys[i].includes("[") && keys[i].includes("]")) {
          const arrayKey = keys[i].split("[")[0];
          const index = parseInt(keys[i].split("[")[1].split("]")[0]);
          if (!current[arrayKey]) current[arrayKey] = [];
          if (!current[arrayKey][index]) current[arrayKey][index] = {};
          current = current[arrayKey][index];
        } else {
          if (!current[keys[i]]) current[keys[i]] = {};
          current = current[keys[i]];
        }
      }
      const lastKey = keys[keys.length - 1];
      current[lastKey] = value;
    };

    const getNestedValue = (obj: any, path: string) => {
      return path.split(".").reduce((o: any, i: string) => {
        if (o == null) return undefined;
        if (i.includes("[") && i.includes("]")) {
          const arrayKey = i.split("[")[0];
          const index = parseInt(i.split("[")[1].split("]")[0]);
          return o[arrayKey] ? o[arrayKey][index] : undefined;
        }
        return o[i];
      }, obj);
    };

    const payloadDatas = await updatePayload(data);
    let imageKeys = [];
    const featuresLength = payloadDatas.field_content_english?.data?.cardData?.length || 0;
    for (let i = 0; i < featuresLength; i++) {
      imageKeys.push(`field_content_english.data.cardData[${i}].image`);
    }

    for (const key of imageKeys) {
      try {
        let field = key.split(".").reduce((o, i) => {
          if (i.includes("[") && i.includes("]")) {
            const arrayKey = i.split("[")[0];
            const index = parseInt(i.split("[")[1].split("]")[0]);
            return o ? o[arrayKey][index] : undefined;
          }
          return o ? o[i] : undefined;
        }, payloadDatas);

        if (field && field[0]) {
          if (field[0].originFileObj) {
            console.log("fieldOriging", field, field[0]?.originFileObj);
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              updateNestedProperty(payloadDatas, key, res.response.data);
            }
          } else if (field[0].url) {
            updateNestedProperty(payloadDatas, key, field[0].url);
          }
        }
      } catch (error) {
        console.error("Error updating image field:", key, error);
      }
    }
    for (let i = 0; i < featuresLength; i++) {
      const englishKey = `field_content_english.data.cardData[${i}].image`;
      const englishImage = getNestedValue(payloadDatas, englishKey);

      const malayKey = `field_content_malay.data.cardData[${i}].image`;
      updateNestedProperty(payloadDatas, malayKey, englishImage);

      const mandarinKey = `field_content_mandarin.data.cardData[${i}].image`;
      updateNestedProperty(payloadDatas, mandarinKey, englishImage);
    }

    if (payloadDatas.field_content_english) {
      payloadDatas.field_content_english = JSON.stringify(payloadDatas.field_content_english);
    }
    if (payloadDatas.field_content_malay) {
      payloadDatas.field_content_malay = JSON.stringify(payloadDatas.field_content_malay);
    }
    if (payloadDatas.field_content_mandarin) {
      payloadDatas.field_content_mandarin = JSON.stringify(payloadDatas.field_content_mandarin);
    }
    let payload = {
      action: action,
      method: method,
      module: "Sustainability",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Sustainability_Landing",
      payload: payloadDatas,
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => ({
    label,
    key,
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
        }
        defaultReviewNotes="Kindly review this Sustainability"
      />
    ),
  });

  const profileChildItems = profileData
    ? profileData?.[0]?.field_content_english?.data?.cardData.filter(Boolean).map((item: any, index: any) => {
        console.log("indexitemfornow", item, index);
        const uniqueKey = `${toUniqueKey(item.title)}ForLanding_${index}`;
        console.log("profileChildItems", item, uniqueKey, fieldData?.landing?.[index]);
        console.log("generateformvalue", createFormConfig(item.title, [index], fieldData?.landing?.[index]));
        return generateFormItem(
          item.title,
          uniqueKey,
          createFormConfig(item.title, [index], fieldData?.landing?.[index]),
          `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "92"}`
        );
      })
    : (() => {
        const fieldContent = profileDataById?.payload?.field_content_english;
        let parsedContent;
        // Validate and safely parse JSON
        if (typeof fieldContent === "string") {
          try {
            parsedContent = JSON.parse(fieldContent);
          } catch (error) {
            console.error("Failed to parse field_content_english:", error);
            parsedContent = null;
          }
        } else if (typeof fieldContent === "object" && fieldContent !== null) {
          parsedContent = fieldContent;
        } else {
          parsedContent = null;
        }
        console.log("parsedContent", parsedContent, fieldContent);
        return (
          parsedContent?.data?.cardData?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toUniqueKey(item.title)}ForLanding_${index}`;
            console.log("profileChildItems", item, uniqueKey);
            console.log("generateformvalue", createFormConfig(item.title, [index], fieldData?.landing?.[index]));
            return generateFormItem(
              item?.title,
              uniqueKey,
              createFormConfig(item?.title, [index], fieldData?.landing?.[index]),
              `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "92"}`
            );
          }) || []
        );
      })();

  profileChildItems.push({
    label: "Page Heading",
    key: "landingPageHeading",
    children: <LandingPageHeading />,
  });

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={profileChildItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
